import { Button, Checkbox, Col, Collapse, Row, Space, Switch, Tag } from "antd";
import Form from "antd/lib/form/Form";
import Text from "antd/lib/typography/Text";
import React from "react";
import AdnCard from "../common/adnCard/AdnCard";
import AdnInput from "../common/adnInput/AdnInput";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import { AdnPhoneInputButton } from "../common/adnPhoneInputButton/AdnPhoneInputButton";
import AdnTextArea from "../common/adnTextArea/AdnTextArea";
import adnYesNoModal from "../common/adnYesNoModal/AdnYesNoModal";
import ManageContactPanel from "./ManageContactPanel";
import "./TextMessagePageForm.css";

const TextMessagePageForm = ({
  form,
  departmentOptions,
  onValuesChange,
  rememberMessage,
  onChangeRememberMessage,
  allSelected,
  setAllSelected,
  onClickAllSelected,
  selectedContacts,
  setSelectedContacts,
  requiresFetch,
  onRemoveContact,
  addPhoneNumber,
  addPhoneNumberError,
  showButton,
  numberOfMessages,
  submitLoading,
  handleSend,
}) => {
  return (
    <div className="text-msg-container">
      <AdnPageTitle title="Send message" />
      <AdnCard>
        <Form
          layout="vertical"
          name="textMessageForm"
          form={form}
          onValuesChange={onValuesChange}
          onFinish={handleSend}
        >
          <Row gutter={16}>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
              <h5>Message</h5>
              <AdnInput
                label="Campaign"
                name="campaign"
                placeholder="What is this text message about?"
                showCount={true}
                maxLength="50"
                rules={[{ required: true, message: "Need to type a subject." }]}
              />
              <AdnTextArea
                label="Message body"
                name="body"
                placeholder="Please input your message."
                showCount={true}
                maxLength="512"
                rules={[{ required: true, message: "Need to type a message." }]}
                autoSize={{ minRows: 6 }}
              />
              <Checkbox
                checked={rememberMessage}
                onChange={onChangeRememberMessage}
              >
                Remember message?
              </Checkbox>
            </Col>
            <Col className="textMessageContacts" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 12 }} xxl={{ span: 12 }}>
              <Row justify="space-between">
                <Col>
                  <h5>Contacts</h5>
                </Col>
                <Col>
                  <Space span={1}>
                    <Text>To Everyone</Text>
                    <Switch
                      checked={allSelected}
                      onClick={onClickAllSelected}
                    />
                  </Space>
                </Col>
              </Row>

              <Text>Send to: </Text>
              <div
                style={{
                  marginBottom: 16,
                }}
              >
                {allSelected && <Tag>All</Tag>}
                {selectedContacts.map(
                  (contact) =>
                    (!allSelected || contact.type == "Phone") && (
                      <Tag
                        key={`${contact.type}:${contact.id}`}
                        closable
                        onClose={(e) => {
                          e.preventDefault();
                          onRemoveContact(contact);
                        }}
                      >
                        {contact.name ? contact.name : contact.phone}
                      </Tag>
                    )
                )}
              </div>
              <Text>Add unregistered number:</Text>
              <div
                style={{
                  marginBottom: 16,
                }}
              >
                <AdnPhoneInputButton
                  buttonText="Add"
                  onClick={(phone) => addPhoneNumber(phone)}
                />
                {addPhoneNumberError && (
                  <Text style={{ color: "red" }}>{addPhoneNumberError}</Text>
                )}
              </div>
              <Collapse collapsible="icon" accordion>
                {departmentOptions.map((department) => (
                  <ManageContactPanel
                    key={department.id}
                    department={department}
                    allSelected={allSelected}
                    setAllSelected={setAllSelected}
                    selectedContacts={selectedContacts}
                    setSelectedContacts={setSelectedContacts}
                    requiresFetch={requiresFetch}
                  />
                ))}
              </Collapse>
            </Col>
          </Row>

          <Row align="middle" style={{ marginTop: 8 }}>
            <Space span={4}>
              {showButton && (
                <Button
                  type="primary"
                  loading={submitLoading}
                  onClick={() => {
                    adnYesNoModal(
                      () => form.submit(),
                      "Are you sure you want to send this message?",
                      "primary",
                      `This message will be sent to ${numberOfMessages} ${numberOfMessages > 1 ? "people" : "person"
                      }.`
                    );
                  }}
                >
                  Send
                </Button>
              )}
              {numberOfMessages > 0 && (
                <Text> You will be sending {numberOfMessages} messages.</Text>
              )}
            </Space>
          </Row>
        </Form>
      </AdnCard>
    </div>
  );
};

export default TextMessagePageForm;
